import React, { useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import useFileDocuments from "../actions/useFileDocuments";
import SearchFIles from "./SearchFIles";
import { useDispatch, useSelector } from "react-redux";
import {
  handleDisableFilter,
  setBlobFilterStates,
} from "~/Pages/Process/actions/attachmentsSlice";
import FolderListSection from "~/components/folder-list-section/FolderListSection";

const TypeFileDocuments = () => {
  const { id, service_id, type } = useParams();
  const location = useLocation();
  const { blobFilterStates } = useSelector((state) => state.attachments);
  const dispatch = useDispatch();

  const {
    states,
    handleClickType,
    fileName,
    setFileName,
    rows,
    first,
    onPageChange,
    setSelectedCategory,
    setCategoryFoldersRefetch,
  } = useFileDocuments({
    id,
    service_id,
    type,
  });
  useEffect(() => {
    dispatch(setBlobFilterStates({}));
  }, []);
  useEffect(() => {
    dispatch(handleDisableFilter(!states?.folders?.length));
  }, [states?.folders]);

  useEffect(() => {
    if (location.state) {
      const { id, code, name, isCategoryFolder } = location.state;
      if (isCategoryFolder) {
        setSelectedCategory({ id, code, name });
      }
    }
  }, [location.state, setSelectedCategory]);
  // Auto-select category folder when navigating from "View in Folder"
  const appliedCategoryRef = useRef(false);
  useEffect(() => {
    const categoryCode = location.state?.categoryCode;
    if (!categoryCode || appliedCategoryRef.current || !states?.folders?.length)
      return;
    const matchingFolder = states.folders.find(
      (f) => f.isCategoryFolder && f.code === categoryCode,
    );
    if (matchingFolder) {
      appliedCategoryRef.current = true;
      setSelectedCategory(matchingFolder);
    }
  }, [location.state, states?.folders]);

  const isEntityInformationWithCategory =
    states?.selectedType?.code === "entity-information" &&
    states?.selectedCategory;

  return (
    <>
      {isEntityInformationWithCategory ? (
        <SearchFIles
          fileName={fileName}
          setFileName={setFileName}
          additionaltag={{ entity: [states?.entity_detail?.name] }}
          states={states}
          first={first}
          rows={rows}
          onPageChange={onPageChange}
          isRootFolder={true}
          categoryFilter={states?.selectedCategory}
          setCategoryFoldersRefetch={setCategoryFoldersRefetch}
        />
      ) : (
        <FolderListSection
          folders={states?.folders}
          loading={states.loading}
          isFilterApplied={!!blobFilterStates?.selectedItems?.length}
          onFolderClick={handleClickType}
          showEmptyState={true}
          filterContent={
            <SearchFIles
              fileName={fileName}
              setFileName={setFileName}
              additionaltag={{ entity: [states?.entity_detail?.name] }}
              states={states}
              first={first}
              rows={rows}
              onPageChange={onPageChange}
              isRootFolder={true}
              setCategoryFoldersRefetch={setCategoryFoldersRefetch}
            />
          }
        />
      )}
    </>
  );
};

export default TypeFileDocuments;
